import { platformAdvantages } from '@/mocks/home';
import { Link } from 'react-router-dom';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary-500 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-500 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            为什么选择bb体育？
          </h2>
          <p className="text-background-300 text-sm md:text-base max-w-xl mx-auto">
            我们以专业的技术、丰富的资源和优质的服务，为全球体育爱好者打造极致的体育娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {platformAdvantages.map((adv) => (
            <div
              key={adv.title}
              className="group p-5 md:p-6 rounded-xl bg-background-800/50 border border-background-700/50 hover:border-primary-500/30 hover:bg-background-800/80 transition-all duration-300"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-500/10 flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110">
                <i className={`${adv.icon} text-primary-400 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 mb-2">
                {adv.title}
              </h3>
              <p className="text-background-400 text-sm leading-relaxed">
                {adv.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            了解更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}